/* Native wishlist (no app dependency). Stores product handles in localStorage. */
(function () {
  var STORAGE_KEY = 'ad_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list } }));
  }

  function isInWishlist(handle) {
    return getWishlist().indexOf(handle) > -1;
  }

  function toggleWishlist(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push(handle);
    }
    saveWishlist(list);
    return idx === -1;
  }

  function refreshButtons() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      var active = list.indexOf(handle) > -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length > 0 ? list.length : '';
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-product-handle');
    toggleWishlist(handle);
    refreshButtons();
  });

  document.addEventListener('wishlist:updated', refreshButtons);
  document.addEventListener('DOMContentLoaded', refreshButtons);
  refreshButtons();

  window.AdWishlist = {
    get: getWishlist,
    toggle: toggleWishlist,
    isInWishlist: isInWishlist
  };
})();
